import React, {useEffect, useState} from 'react';
import {formatDate} from "../../../../utils/utils";
import moment from "moment/moment";
import {Exercise} from "../Exercise";
import {DatePicker} from "../../../General/DatePicker/DatePicker";
import {DeleteModal} from "../../../General/DeleteModal/DeleteModal";
import {AddModal} from "../AddModal";
import {CloseButton} from "../CloseButton";
import {SortableListWithContext} from "../../../SortableList/SortableList";
import {AddButton} from "../../../General/AddButton";

let deleteTimeout;

export const Session = ({setExercises, session, updateExercise, setSessionDate, deleteSession, addExercise, sessions, sessionIndex, old}) => {
    const [editing, setEditing] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [adding, setAdding] = useState(false);

    useEffect(() => {
        if (editing) return;
        const empty = e => !(e.reps?.length > 0 || e.sets?.length > 0  || e.weight?.length > 0)
        if (session?.exercises?.some(e => empty(e) && e.marked)) {
            console.log('florpo!');
            const newVal = session.exercises.filter(e => !(
                empty(e) && e.marked
            ))
            setExercises(newVal)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editing]);

    useEffect(() => {
        if (!session.new || editing) return;
        setEditing(true);
        old();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [session]);

    const touchMove = () => {
        if (!deleteTimeout) return;
        deleteTimeout = clearTimeout(deleteTimeout);
    }

    const touchStart = () => {
        deleteTimeout = setTimeout(() => {
            setDeleting(true);
            deleteTimeout = undefined;
        }, 1000);
    }

    const touchEnd = () => {
        deleteTimeout = clearTimeout(deleteTimeout);
    }

    const renderDeleteModal = () => {
        if (!deleting) return null;
        return (
            <DeleteModal
                prompt={`Slette treningssessjon ${formatDate(moment(session.date), true)}?`}
                close={() => setDeleting(false)}
                confirm={deleteSession}
            />
        )
    }

    return (
        <>
            {renderDeleteModal()}

            <div
                className={`session rounded thing ${editing ? 'editing' : ''}`}
                onClick={() => {
                    if (!editing) setEditing(true)
                }}
                onTouchStart={editing ? undefined : touchStart}
                onTouchMove={editing ? undefined : touchMove}
                onTouchEnd={touchEnd}
            >
                {
                    editing ? (
                        <>
                            <DatePicker
                                date={session.date}
                                onDateChange={d =>
                                    setSessionDate(d.startOf('day'))
                                }
                            />
                            <CloseButton onClick={() => setEditing(false)}/>
                        </>
                    ) : (
                        <h3>
                            {formatDate(moment(session.date))}
                        </h3>
                    )
                }
                {session.label && (<h2>{session.label}</h2>)}
                {
                    editing ? (
                        <SortableListWithContext
                            items={session.exercises}
                            setItems={setExercises}
                            getId={i => i.name}
                            renderItem={(item, i) => (
                                <Exercise
                                    key={item.name}
                                    exercise={item}
                                    setExercise={(ne) => updateExercise(ne, i)}
                                    editing={editing}
                                    sessionIndex={sessionIndex}
                                    sessions={sessions}
                                />
                            )}
                        />
                    ) : session.exercises.map((e, i) => (
                        <Exercise
                            key={e.name}
                            exercise={e}
                            setExercise={(ne) => updateExercise(ne, i)}
                            editing={editing}
                            className="withMargins"
                        />
                    ))
                }

                {editing && <AddButton
                    onClick={() => setAdding(true)}
                />}
                {adding &&
                    <div className="tricky thing">
                        <AddModal
                            heading="Ny øvelse i dag:"
                            close={() => setAdding(false)}
                            confirm={(name, onSuccess) => {addExercise(name, onSuccess)}}
                        />
                    </div>
                }
            </div>
        </>

    );
}